/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { locationPhysicalTypeIdGet } from '../fn/location-physical-type/location-physical-type-id-get';
import { LocationPhysicalTypeIdGet$Params } from '../fn/location-physical-type/location-physical-type-id-get';
import { LocationPhysicalTypeModel } from '../models/location-physical-type-model';
import { LocationPhysicalTypeModelSearchResultModel } from '../models/location-physical-type-model-search-result-model';
import { locationPhysicalTypePost } from '../fn/location-physical-type/location-physical-type-post';
import { LocationPhysicalTypePost$Params } from '../fn/location-physical-type/location-physical-type-post';
import { locationPhysicalTypeSearchLocationPhysicalTypePost } from '../fn/location-physical-type/location-physical-type-search-location-physical-type-post';
import { LocationPhysicalTypeSearchLocationPhysicalTypePost$Params } from '../fn/location-physical-type/location-physical-type-search-location-physical-type-post';

@Injectable({ providedIn: 'root' })
export class MDILocationPhysicalTypeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `locationPhysicalTypeSearchLocationPhysicalTypePost()` */
  static readonly LocationPhysicalTypeSearchLocationPhysicalTypePostPath = '/LocationPhysicalType/SearchLocationPhysicalType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationPhysicalTypeSearchLocationPhysicalTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  locationPhysicalTypeSearchLocationPhysicalTypePost$Response(params?: LocationPhysicalTypeSearchLocationPhysicalTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<LocationPhysicalTypeModelSearchResultModel>> {
    return locationPhysicalTypeSearchLocationPhysicalTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationPhysicalTypeSearchLocationPhysicalTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  locationPhysicalTypeSearchLocationPhysicalTypePost(params?: LocationPhysicalTypeSearchLocationPhysicalTypePost$Params, context?: HttpContext): Observable<LocationPhysicalTypeModelSearchResultModel> {
    return this.locationPhysicalTypeSearchLocationPhysicalTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<LocationPhysicalTypeModelSearchResultModel>): LocationPhysicalTypeModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `locationPhysicalTypeIdGet()` */
  static readonly LocationPhysicalTypeIdGetPath = '/LocationPhysicalType/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationPhysicalTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationPhysicalTypeIdGet$Response(params: LocationPhysicalTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<LocationPhysicalTypeModel>> {
    return locationPhysicalTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationPhysicalTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationPhysicalTypeIdGet(params: LocationPhysicalTypeIdGet$Params, context?: HttpContext): Observable<LocationPhysicalTypeModel> {
    return this.locationPhysicalTypeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<LocationPhysicalTypeModel>): LocationPhysicalTypeModel => r.body)
    );
  }

  /** Path part for operation `locationPhysicalTypePost()` */
  static readonly LocationPhysicalTypePostPath = '/LocationPhysicalType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationPhysicalTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  locationPhysicalTypePost$Response(params?: LocationPhysicalTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return locationPhysicalTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationPhysicalTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  locationPhysicalTypePost(params?: LocationPhysicalTypePost$Params, context?: HttpContext): Observable<string> {
    return this.locationPhysicalTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
